import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const fundingTypes = (state: RootState) => state.supportAtHome.fundingTypes;

export const selectFundingTypes = (state: RootState) => fundingTypes(state).rows;

export const selectFundingTypesLoading = (state: RootState) => fundingTypes(state).loading;
export const selectCurrentFundingType = (state: RootState) => fundingTypes(state).row;
export const selectClientFundingTypes = (state: RootState) => fundingTypes(state).clientFundingTypes;
export const selectSahFundingTypes = (state: RootState) => fundingTypes(state).sahFundingTypes;
export const selectLookupFundingTypes = createSelector([selectFundingTypes], (fundingTypesList) =>
  fundingTypesList.map((fundingType) => ({
    id: fundingType.id,
    name: fundingType.name,
  })),
);
export const selectClientPackageScheduleFundingType = createSelector(
  [
    (state: RootState) => state.main.clientPackageSchedules.rows,
    (state: RootState, package_fixed_id: number) => package_fixed_id,
  ],
  (schedules, package_fixed_id) => {
    if (!schedules || !Array.isArray(schedules)) return undefined;
    const schedule = schedules.find((schedule) => Number(schedule.package.id) === Number(package_fixed_id));
    return schedule?.package?.funding_type;
  },
);
